const CheckQuyenThaoTacXuLy = (canBoDangXuLyInfo) => {

  let check = false;

  if (canBoDangXuLyInfo && localStorage.getItem('userInfo')) {

    let data = JSON.parse(localStorage.getItem('userInfo'));

    canBoDangXuLyInfo.map((item, i) => {
      if (item.donViId == data.donViId) {

        if (item.congChucId) {
          if (item.congChucId == data.id) {
            check = true;
          }
          else {
            check = false;
          }
            
        } else {
          check = true;
        }
      }
    })
  }
  return check;
}

export { CheckQuyenThaoTacXuLy };


// WEBPACK FOOTER //
// ./src/components/modules/login/CheckQuyenThaoTacXuLy.js